<template>
    <div class="divide page-wrapper" :style="{ '--header-height': `${storeCommon.headerHeight}px` }" v-if="storeCommon.systemInfo.inQmApp">
        <QHeader v-if="storeCommon.canShowNav" :config="navConfig" @share="onShowShare">
            <template #middle>
                <div class="title-img"></div>
            </template>
        </QHeader>
        <div class="header-placeholder" v-else></div>

        <div class="divide-title"></div>
        <MineCash @withdraw="onWithdrawAll" />
        <RedPacketMain />
        <RedPacketCalendar v-if="loadFinish" />
        <InviteModule />
        <ActivityGuide />
        <QSlogan :title="storeCommon.systemInfo.isIos ? '本活动与设备制作商Apple Inc.无关' : ''" :client="'freereader'"></QSlogan>
        <FixedLeft />
        <FixedRight />
        <QPop systemBackName="red-packet" class="g-pop-nobg g-pop-dark-overlay" :contentIsScroll="false" v-model="showRedPacket">
            <PopRedPacket :count="popData.count" @invite="onShowShare" />
        </QPop>
        <QPop systemBackName="invite" class="g-pop-dark-overlay" :contentIsScroll="false" v-model="store.popManage.inviteCode">
            <PopInviteCode />
        </QPop>
        <SharePoster class="g-pop-dark-overlay" v-model="store.popManage.share" v-if="store.mainData.invite_code"></SharePoster>

        <div class="carousel-container">
            <QCarousel :list="carouselList">
                <template #default="{ item }">
                    <div class="carousel-container-item">
                        <p class="carousel-container-item-text" v-for="value in item" :key="value">{{ value }}</p>
                    </div>
                </template>
            </QCarousel>
        </div>
    </div>
    <PageShareLand v-else></PageShareLand>
</template>
<script lang="ts" setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { usePageBaseInit } from '@qm-activity/common/hooks';
import QHeader from '@qm-activity/common/components/q-header/index.vue';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { onInterceptKeyBack, closeWebview, jsbStorage, jsbReportV3, jsbSupportMap, openWebview } from '@q-front-npm/jsbridge';
import { QPop, QSlogan } from '@q-front-npm/h5-ui';
import { navConfig } from './assets/ts/const';
import MineCash from './components/mine-cash/index.vue';
import RedPacketMain from './components/red-packet-main/index.vue';
import RedPacketCalendar from './components/red-packet-calendar/index.vue';
import InviteModule from './components/invite-module/index.vue';
import ActivityGuide from './components/activity-guide/index.vue';
import FixedRight from './components/fixed-right/index.vue';
import FixedLeft from './components/fixed-left/index.vue';
import PopRedPacket from './components/pop-red-packet/index.vue';
import { useStore } from './store';
import SharePoster from './components/share-poster/index.vue';
import PopInviteCode from './components/pop-invite-code/index.vue';
import QCarousel from '@qm-activity/common/components/q-carousel/index.vue';
import { apiSupportCashHome, apiWithdrawAll } from './http/api';
import { apiSupport, apiSupportResult, apiUserInfo } from '@/http/api';
import { apiInitWxConfig } from '@common/http/api';
import PageShareLand from '@divide/components/page-share-land/index.vue';
import { sleep } from 'radash';
import { formatDate } from '@qm-activity/common';
import { copyToClipboard } from '@qm-activity/common/assets/ts/utils';
const instance = getCurrentInstance()!;
jsbStorage.setNameSpace('freereaderMarathon2026');
const storeCommon = useStoreCommon();
const store = useStore();
usePageBaseInit();

const showRedPacket = ref(false);

const onShowShare = () => {
    if (jsbSupportMap.app.share) {
        store.setPopManage('share', true);
    } else {
        instance.proxy.$toast('请更新至最新版本以参与活动');
    }
};

const toCarouselList = (list: Record<string, any>[] = []) => {
    const msgList = list.map((item) => item?.text).filter(Boolean);
    const result: string[][] = [];
    for (let i = 0; i < list.length; i += 2) {
        result.push(msgList.slice(i, i + 2));
    }
    return result;
};
// 弹窗提示 - 获得红包
const popData = ref<Record<string, any>>({});
const onShowGeyRedPacketPop = async() => {
    const { uid, } = storeCommon.userInfo;
    const today = formatDate(Date.now(), 'YYYY-MM-DD');
    const key = `${uid}_pop_${today}`;
    const prev = (await jsbStorage.get(key)) || 0;
    const count = store.mainData.today_help_count - prev;
    if (count > 0) {
        showRedPacket.value = true;
        popData.value = {
            count,
        };
        jsbStorage.set(key, store.mainData.today_help_count);
    }
};

// 是否引导跳转到主页
const isGuideToIndex = async() => {
    if (storeCommon.urlParams.from === 'index') {
        return;
    }
    const key = `${storeCommon.userInfo.uid}_isGuideToIndex`;
    const cache = await jsbStorage.get(key);
    if (cache) {
        return;
    }
    jsbStorage.set(key, 1);
    store.setMainData({
        guideToIndex: true,
    });
};

const carouselList = ref<string[][]>([]);
const loadFinish = ref(false);
const getSupportCashHome = async() => {
    const res = await apiSupportCashHome();
    // 1=进行中 2=已结束 3=未开始
    res.isEnd = res.cash_activity_status !== '1';
    res.today_help_count = Math.min(res.today_help_count, 50);
    store.setMainData(res);
    carouselList.value = toCarouselList(res?.scroll_messages || []);
    loadFinish.value = true;
    storeCommon.setUserInfo({
        invite_code: res.invite_code,
        invite_code_pass: res.invite_code_pass,
    });
    if (res.share_cash_popup_data.help_count > 0) {
        showRedPacket.value = true;
    } else if (!res.isEnd) {
        await isGuideToIndex();
        onShowGeyRedPacketPop();
    }
};

let isLoading = false;
const onWithdrawAll = async() => {
    if (isLoading) {
        return;
    }
    isLoading = true;
    try {
        await apiWithdrawAll();
        instance.proxy.$toast('提现成功');
        getSupportCashHome();
        openWebview(`https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/details?full_screen=3&tab=1`);
    } finally {
        isLoading = false;
    }
};
// 助力流程
const onSupport = async() => {
    if (!storeCommon.systemInfo.inQmApp) {
        return;
    }
    const { code, source, } = storeCommon.urlParams;
    if (source === 'help') {
        const res = await apiSupportResult();
        res.result && instance.proxy.$toast(res.result);
        return;
    }
    if (!code) {
        return;
    }
    await apiSupport({ invite_code: code, });
    await sleep(1500);
    const res = await apiSupportResult();
    const { result, status, } = res;

    if (status === '1') {
        if (storeCommon.userInfo.isLogin) {
            store.setMainData({
                today_help_count: store.mainData.today_help_count + 1,
            });
            onShowGeyRedPacketPop();
        } else if (result) {
            instance.proxy.$toast(result);
        }
    } else if (result) {
        instance.proxy.$toast(result);
    }
};

// 获取用户信息
const getUserInfo = async() => {
    if (!storeCommon.systemInfo.inQmApp) {
        return;
    }
    await storeCommon.getUserInfo(apiUserInfo, true);
    await getSupportCashHome();
    onSupport();
};
getUserInfo();
// 物理返回拦截处理 - 自动关闭显示的弹窗 QPop 添加 systemBackName 属性
(window as any).onListenSystemBack = onInterceptKeyBack;
(window as any).onSystemBackCb = (type: string) => {
    if (type === 'no-show-pop') {
        closeWebview();
    }
};

onMounted(() => {
    saShow();
});

const saShow = () => {
    const { code, source, } = storeCommon.urlParams;
    jsbReportV3('2026_mainpage_#_show', { page_name: '瓜分', resource_page: source || '', trace_id: code || '', });
};
</script>
<style lang="scss">
@import '@divide/assets/styles/iconfont.scss';
@import '@divide/assets/styles/sprites.scss';
@import '@qm-activity/common/assets/styles/iconfont.scss';
@import '@common/styles/common.scss';
.divide {
    position: relative;
    @include sprites-divide($divide-sprites);
    min-height: 100vh;
    background: url('@divide/assets/images/divide_mainbg@3x.png') no-repeat;
    background-size: 100% 1052px;
    padding: var(--header-height) 32px 0;
}
body {
    background: #ffeee9;
}

.module {
    position: relative;
    margin-top: 20px;
    padding: 24px;
    background: #ffffff;
    border-radius: 16px;

    &-title {
        font-weight: bold;
        font-size: 30px;
        color: #682121;
        line-height: 42px;

        &-1 {
            margin-left: 8px;
        }
    }
}
</style>
<style lang="scss" scoped>
.title-img {
    width: 100%;
    height: 36px;
    background: url('@divide/assets/images/divide_headbg@3x.png') no-repeat center;
    background-size: auto 100%;
}
.divide-title {
    width: 100%;
    height: 84px;
    background: url('@divide/assets/images/divide_title@3x.png') no-repeat center;
    background-size: auto 100%;
}
.carousel-container {
    position: absolute;
    top: var(--header-height);
    left: 20px;
    z-index: 9;
    margin-top: 200px;
    height: 108px;
    overflow: hidden;
    &-item {
        padding: 6px 0;
        &-text {
            height: 42px;
            line-height: 42px;
            background-color: rgba(109, 59, 59, 0.2);
            padding: 0 16px;
            font-size: 22px;
            color: #ffffff;
            border-radius: 42px;
            &:first-child {
                margin-bottom: 12px;
            }
        }
    }
}
</style>
